import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const authenticationModule = namespace('authentication');
let SignInButton = class SignInButton extends Vue {
    created() {
        this.initMSAL();
    }
    async signIn() {
        if (Vue.prototype.$msal) {
            this.$emit('setAuthLoading', true);
            await this.fetchAccessToken();
            this.$emit('setAuthLoading', false);
        }
    }
};
__decorate([
    authenticationModule.Getter
], SignInButton.prototype, "account", void 0);
__decorate([
    authenticationModule.Action
], SignInButton.prototype, "initMSAL", void 0);
__decorate([
    authenticationModule.Action
], SignInButton.prototype, "fetchAccessToken", void 0);
SignInButton = __decorate([
    Component
], SignInButton);
export default SignInButton;
